export const locale = {
    lang: 'en',
    data: {
        ORDER_DETAIL_MODAL_RATING: {
            TITLE: 'Order rating',
            RATING_AVERAGE: 'Average rating',
            DESCRIPTION: 'Description',
        },
    },
};
